import { supabase } from './auth';
import { Race } from '../types';
import { localDate } from '../utils/date';

export const listRaces = async (): Promise<Race[]> => {
  const { data, error } = await supabase
    .from('races')
    .select('*')
    .gte('race_date', localDate())
    .order('race_date', { ascending: true });

  if (error) throw error;
  return (data ?? []) as Race[];
};

export const addRace = async (race: {
  name: string;
  race_date: string;
  distance_miles: number | null;
  priority: 'A' | 'B' | 'C';
  goal?: string | null;
}): Promise<Race> => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not signed in');

  const { data, error } = await supabase
    .from('races')
    .insert([{ ...race, user_id: user.id }])
    .select()
    .single();

  if (error) throw error;
  return data as Race;
};

export const updateRace = async (
  id: string,
  fields: Partial<Pick<Race, 'name' | 'race_date' | 'distance_miles' | 'priority' | 'goal'>>
): Promise<Race> => {
  const { data, error } = await supabase
    .from('races')
    .update(fields)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as Race;
};

export const deleteRace = async (id: string): Promise<void> => {
  const { error } = await supabase.from('races').delete().eq('id', id);
  if (error) throw error;
};

/** Whole days from today until the race (0 = today). */
export const daysUntil = (isoDate: string): number => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const race = new Date(`${isoDate}T00:00:00`);
  return Math.round((race.getTime() - today.getTime()) / 86400000);
};
